import React, { useState, useEffect, useRef } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { FaEdit, FaSave, FaTrash } from "react-icons/fa";
import axios from 'axios';
import './Leadership.css';


// --- Styles ---
const sectionStyle = {
  maxWidth: "1350px",
  margin: "0 auto",
  border: "1px solid #bbb",
  borderRadius: "10px",
  marginTop: "50px",
};
const headerTextStyle = {
  fontSize: "32px",
  fontWeight: "700",
  textAlign: "center",
  marginBottom: "20px",
  color: "rgb(177 93 198)",
};
const cardStyle = {
  backgroundColor: "#fff",
  borderRadius: "16px",
  border: "2px solid #b15cd6",
  padding: "30px 20px",
  textAlign: "center",
  margin: "0 10px",
  width: "250px",
  marginBottom: "20px",
  position: "relative",
};
const imageStyle = {
  width: "120px",
  height: "120px",
  borderRadius: "50%",
  objectFit: "cover",
  marginBottom: "20px",
  border: "2px solid #b15dc6",
  cursor: "pointer",
};
const nameStyle = { fontSize: "22px", fontWeight: "600", color: "#333", marginBottom: "6px" };
const titleStyle = { fontSize: "16px", fontWeight: "500", color: "#b15dc6", marginBottom: "12px" };
const descStyle = {
  fontSize: "14px",
  color: "#555",
  lineHeight: "1.5",
  whiteSpace: "pre-wrap",
  overflow: "auto",
  overflowWrap: "break-word",
  wordBreak: "break-word",
  maxHeight: "100px",
};
const inputStyle = {
  marginBottom: "10px",
  width: "100%",
  padding: "5px",
  fontSize: "14px",
};
const editButtonStyle = {
  position: "absolute",
  top: "5px",
  right: "40px",
  background: "transparent",
  border: "none",
  cursor: "pointer",
  fontSize: "20px",
};

const LeadershipCardItem = ({ leader, onSaveEdit, onDelete }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [editedData, setEditedData] = useState({ ...leader });
  const fileInputRef = useRef(null);

  const handleEditToggle = () => {
    if (isEditing) onSaveEdit(editedData);
    setIsEditing(!isEditing);
  };

  const handleImageClick = () => {
    if (isEditing) fileInputRef.current.click();
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setEditedData((prev) => ({ ...prev, image: reader.result }));
      };
      reader.readAsDataURL(file);
    }
  };

  return (
    <div style={cardStyle}>
      <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
        <img
          src={editedData.image}
          alt={editedData.name}
          style={imageStyle}
          onClick={handleImageClick}
        />
        {isEditing && (
          <input
            type="file"
            accept="image/*"
            ref={fileInputRef}
            onChange={handleImageChange}
            style={{ display: "none" }}
          />
        )}
        {isEditing ? (
          <>
            <input
              style={inputStyle}
              value={editedData.name}
              onChange={(e) => setEditedData({ ...editedData, name: e.target.value })}
            />
            <input
              style={inputStyle}
              value={editedData.designation}
              onChange={(e) => setEditedData({ ...editedData, designation: e.target.value })}
            />
            <textarea
              style={inputStyle}
              value={editedData.description}
              onChange={(e) => setEditedData({ ...editedData, description: e.target.value })}
            />
          </>
        ) : (
          <>
            <h3 style={nameStyle}>{editedData.name}</h3>
            <p style={titleStyle}>{editedData.designation}</p>
            <p style={descStyle}>{editedData.description}</p>
          </>
        )}
        <button onClick={handleEditToggle} style={editButtonStyle}>
          {isEditing ? <FaSave style={{ color: "blue" }} /> : <FaEdit style={{ color: "blue" }} />}
        </button>
        <button
          onClick={() => onDelete(leader.teamId)} // Pass the team member ID to handleDelete
          style={{ ...editButtonStyle, marginRight: "-40px" }}
        >
          <FaTrash style={{ color: "red" }} />
        </button>
      </div>
    </div>
  );
};

const LeadershipCard = () => {
  const [leadershipData, setLeadershipData] = useState([]);
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [newMember, setNewMember] = useState({
    name: "",
    designation: "",
    description: "",
    image: "",
  });
  const [vendorId, setVendorId] = useState(null);
  useEffect(() => {
    const storedVendorId = localStorage.getItem("vendorId");
    if (storedVendorId) {
      setVendorId(storedVendorId);
      fetchTeamMembers(storedVendorId); // Call the function with vendorId
    }
  }, []);

  const fetchTeamMembers = async (vendorId) => {
    const token = localStorage.getItem("authToken"); // ✅ Get token

    if (!token) {
      alert("Auth token not found. Please log in again.");
      return;
    }

    try {
      const response = await fetch(
        `https://backend.maamaas.com/food/adminteam/getall/${vendorId}`,
        {
          method: "GET",
          headers: {
            "Authorization": `Bearer ${token}`, // ✅ Include token in headers
          },
        }
      );

      if (response.ok) {
        const data = await response.json();
        const formatted = data.map((member) => ({
          ...member,
          image: `data:image/jpeg;base64,${member.image}`,
          teamId: member.teamId,
        }));

        setLeadershipData(formatted);
      } else {
        alert("Failed to fetch team members.");
      }
    } catch (err) {
      alert("Error fetching team members: " + err.message);
    }
  };


  const handleDeleteMember = async (teamId) => {
    const confirmDelete = window.confirm('Are you sure you want to delete this member?');
    if (!confirmDelete) return;

    const token = localStorage.getItem("authToken"); // ✅ Retrieve token

    if (!token) {
      alert("Auth token not found. Please log in again.");
      return;
    }

    try {
      const response = await axios.delete(
        `https://backend.maamaas.com/food/adminteam/delete/${teamId}`,
        {
          headers: {
            "Authorization": `Bearer ${token}`, // ✅ Token added here
          },
        }
      );

      if (response.status === 200) {
        alert('Member deleted successfully!');
        setLeadershipData((prevData) => prevData.filter((item) => item.teamId !== teamId));
      } else {
        alert('Failed to delete member');
      }
    } catch (error) {
      console.error('Delete error:', error);
      alert('An error occurred while deleting the member');
    }
  };


  const handleSaveEdit = async (editedMember) => {
    const token = localStorage.getItem("authToken"); // ✅ Get token from localStorage

    if (!token) {
      alert("Auth token not found. Please log in again.");
      return;
    }

    try {
      const cleanedImage = editedMember.image.replace(/^data:image\/[a-z]+;base64,/, "");
      const payload = { ...editedMember, image: cleanedImage, vendorId };

      const response = await fetch(
        `https://backend.maamaas.com/food/adminteam/editbyid/${editedMember.teamId}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`, // ✅ Token included here
          },
          body: JSON.stringify(payload),
        }
      );

      if (response.ok) {
        alert("Member updated successfully.");
      } else {
        const errText = await response.text();
        alert("Update failed: " + errText);
      }
    } catch (err) {
      alert("Update error: " + err.message);
    }
  };


  const handleNewImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setNewMember((prev) => ({ ...prev, image: reader.result }));
      };
      reader.readAsDataURL(file);
    }
  };

  const handleAddMember = async () => {
    if (!vendorId || !newMember.name || !newMember.designation || !newMember.description || !newMember.image) {
      console.log("Missing fields:", { vendorId, ...newMember });
      return alert("Please fill all fields.");
    }

    const token = localStorage.getItem("authToken"); // ✅ Get token

    if (!token) {
      alert("Auth token not found. Please log in again.");
      return;
    }

    const cleanedImage = newMember.image.replace(/^data:image\/[a-z]+;base64,/, "");
    const payload = { ...newMember, image: cleanedImage }; // Removed userId from payload

    try {
      const response = await fetch(
        `https://backend.maamaas.com/food/adminteam/addteam/${vendorId}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`, // ✅ Include token in header
          },
          body: JSON.stringify(payload),
        }
      );

      const responseText = await response.text();
      console.log("Add response:", response.status, responseText);

      if (response.ok) {
        fetchTeamMembers(vendorId); // Make sure you're using vendorId here
        setNewMember({ name: "", designation: "", description: "", image: "" });
        setIsAddModalOpen(false);
      } else {
        alert("Add failed: " + responseText);
      }
    } catch (err) {
      alert("Add error: " + err.message);
    }
  };


  const settings = {
    dots: false,
    infinite: leadershipData.length > 3,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 3000,
    slidesToShow: Math.min(3, leadershipData.length),
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: Math.min(2, leadershipData.length),
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 480, // For very small devices
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };


  return (
    <section style={sectionStyle} className="our-team-data-code">
      <div style={{ display: "flex", gap: "20px", justifyContent: "center", marginTop: "20px" }}>
        <h1 style={headerTextStyle}>OUR TEAM</h1>
        <button
          onClick={() => setIsAddModalOpen(true)}
          style={{
            height: "35px",
            borderRadius: "5px",
            border: "none",
            background: "#b15cd6",
            color: "#fff",
            fontWeight: "bold",
            cursor: "pointer",
            width: "80px",
          }}
        >
          Add+
        </button>
      </div>

      {/* Add Member Modal */}
      {isAddModalOpen && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: "rgba(0,0,0,0.5)",
            zIndex: 10,
          }}
        >
          <div
            style={{
              maxWidth: "400px",
              margin: "auto",
              background: "white",
              borderRadius: "8px",
              padding: "20px",
              position: "relative",
              top: "50%",
              transform: "translateY(-50%)",
            }}
          >
            <h2 style={{ textAlign: "center", marginBottom: "20px" }}>Add New Team Member</h2>
            <input
              type="text"
              placeholder="Name"
              style={inputStyle}
              value={newMember.name}
              onChange={(e) => setNewMember({ ...newMember, name: e.target.value })}
            />
            <input
              type="text"
              placeholder="Designation"
              style={inputStyle}
              value={newMember.designation}
              onChange={(e) => setNewMember({ ...newMember, designation: e.target.value })}
            />
            <textarea
              placeholder="Description"
              style={inputStyle}
              value={newMember.description}
              onChange={(e) => setNewMember({ ...newMember, description: e.target.value })}
            />
            <input
              type="file"
              accept="image/*"
              onChange={handleNewImageChange}
              style={inputStyle}
            />
            <div style={{ textAlign: "center", marginTop: "20px" }}>
              <button
                onClick={handleAddMember}
                style={{
                  padding: "8px 16px",
                  backgroundColor: "#4CAF50",
                  color: "white",
                  border: "none",
                  borderRadius: "4px",
                  cursor: "pointer",
                }}
              >
                Add Member
              </button>
              <button
                onClick={() => setIsAddModalOpen(false)}
                style={{
                  padding: "8px 16px",
                  backgroundColor: "#f44336",
                  color: "white",
                  border: "none",
                  borderRadius: "4px",
                  cursor: "pointer",
                  marginLeft: "10px",
                }}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      <Slider {...settings}>
        {leadershipData.map((member) => (
          <LeadershipCardItem
            key={member.teamId}
            leader={member}
            onSaveEdit={handleSaveEdit}
            onDelete={handleDeleteMember}
          />
        ))}
      </Slider>
    </section>
  );
};

export default LeadershipCard;
